import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue'
import App from './App.vue'
import router from './router'
import { ApiError } from './api/client'
import { useAppErrorStore } from './stores/appError'

// Broadsheet design system (light newsprint; see docs/design/broadsheet-reference.html).
import './styles/broadsheet.css'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(createHead())

// Global safety net: an uncaught error (a 5xx from an API call a view didn't handle, or a component
// crash) routes to the friendly /error page instead of leaving a blank screen. Views that catch
// their own errors (most do) keep showing inline context; a 4xx is left to the originating view.
app.config.errorHandler = (err) => {
  console.error(err)
  if (router.currentRoute.value.name === 'server-error') return
  const appError = useAppErrorStore(pinia)
  if (err instanceof ApiError) {
    if (err.status < 500) return
    appError.set(err.status, err.message)
  } else {
    appError.set(null, err instanceof Error ? err.message : String(err))
  }
  void router.push('/error')
}

app.mount('#app')
